import { Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import PaymentHistoryListingComponent from './PaymentHistoryListingComponent';

import { ArrowLeftIcon } from '../../../../components/shared/CustomIcons';

import { ROUTES } from '../../../../constants/paths';

const PaymentHistoryListing = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(ROUTES.PROFILE);
  };

  return (
    <Box sx={{ bgcolor: 'grey.50', px: 2, py: 8 }} className="flex-1">
      <Box sx={{ px: 1 }} className="d-flex align-items-center">
        <IconButton
          aria-label="back"
          sx={{ p: 0, mt: -2 }}
          onClick={handleBackClick}
        >
          <ArrowLeftIcon sx={{ fontSize: 40, color: 'text.primary' }} />
        </IconButton>
      </Box>
      <Box sx={{ gap: 1.5 }} className="d-flex align-items-center flex-1">
        <Typography
          variant="h5"
          sx={{ color: 'grey.900', pb: 2, pl: 1, ml: 3, mb: 3 }}
        >
          Payment History
        </Typography>
      </Box>
      <Box
        sx={{
          overflowY: 'auto',
          scrollbarWidth: 'none', // For Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // For Chrome, Safari, and Edge
          },
        }}
      >
        <PaymentHistoryListingComponent />
      </Box>
    </Box>
  );
};

export default PaymentHistoryListing;
